<div fxFlex class='popupForm__content'>
  <mat-progress-bar *ngIf='loading' class='fixed extreme-tl' mode='indeterminate'></mat-progress-bar>
  <div
    class='lightbox-content'
    [fxLayout]="!cService.isPcViewport || dfService.widenForm ? 'column' : 'row'"
    [style.height]="!cService.isPcViewport || dfService.widenForm ? '92%' : ''"
  >
    <div
      class='padding-20 form-container'
      [fxFlex]="!cService.isPcViewport || dfService.widenForm ? '100' : data.showGallery ? '32.5' : ''"
    >
      <div *ngIf='data.showGallery && !data.galleryHasContent' class='error-supporting-documents-not-provided'>
        <mat-icon class='error-icon'>priority_high</mat-icon>
        <span class='error-text'>{{ 'GENERIC.supportingDocumentsNotProvided' | translate }}</span>
      </div>
      <intervention-info
        [selectedInterventionHistory]='dfService.launchedInterventionHistory'
      ></intervention-info>
      <!-- Form -->
      <vrm-dynamic-forms
        *ngIf='dfService.dynamicFormIsVisible'
        [class.hide-print-button]='hidePrintButton'
        (onSave)='saveForm($event)'
        (onComplete)='confirmSubmission($event)'
        [fontsize]='16'
        [formBodyHeight]="
					cService.isPcViewport ? (data.showGallery && !data.galleryHasContent ? '72vh' : '80vh') : '80vh'
				"
        [autoSaveForm]='
					dfService.interventionsToAutosave.includes(dfService.launchedIntervention) ? true : false
				'
        [showSaveButton]='
					dfService.interventionsToAutosave.includes(dfService.launchedIntervention) ? true : false
				'
        [showPrintButton]='
					cService.userProfile.vrmFormHidePrintButton[launchedFormName] === cService.permLevels.FALSE
				'
        [hasCompleteButton]='!hasSaveAndCompleteButtons'
        [hasSaveAndCompleteButtons]='hasSaveAndCompleteButtons'
        [saveButtonOptions]='saveButtonOptions'
        [saveAndCompleteButtonOptions]='saveAndCompleteButtonOptions'
        [readonly]='dfService.formIsReadonly'
        [formComponentStructure]='dfService.currentFormStruct'
        [existingFormData]='dfService.selectedDynamicFormData'
        [permission]='cService.userProfile.companySettings'
        [isMobileViewport]='cService.isMobileViewport'
        [companyColor]="'#' + cService.userProfile?.HqColour"
        [languageCode]='cService.selectedLanguage.code'
        [isRtl]='cService.selectedLanguage?.isRtl'
        [environment]='environment'
      >
      </vrm-dynamic-forms>
      <div class='padding-20 form-footer' *ngIf='canCreateClaim'>
        <button
          class='create-claim-all-btn'
          mat-button
          vrm-button
          [style.background-color]="'#' + cService.userProfile.HqColour"
          (click)='onCreateClaim()'
        >
          {{ 'GENERIC.createClaim' | translate }}
        </button>
      </div>
    </div>
    <span fxFlex></span>
    <vrm-gallery-container
      [fxFlex]="!cService.isPcViewport || dfService.widenForm ? '100' : data.showGallery ? '65.5' : ''"
      [fxLayout]="!cService.isPcViewport || dfService.widenForm ? 'column' : 'row'"
      *ngIf='data.showGallery'
      [loading]='loading'
      [galleryHasContent]='data.galleryHasContent'
      (onLoad)='onGalleryFinishedLoading()'
    ></vrm-gallery-container>
  </div>
  <!-- Close-->
  <button type='button' class='popupForm__close' (click)='dialog.close()' vrm-bg-color>
    <mat-icon>close</mat-icon>
  </button>
</div>
